module.exports = __webpack_public_path__ + "static/media/submersible.baf05825.jpg";